module.exports = __webpack_public_path__ + "static/AdobeStock_241450546_80-cdc8ac8f301d2ea3e238e919e7c18b62.jpg";